const translations = {
  addAUser: 'Add a user to the group',
};

export default translations;
